import {officeReducer, authReducer} from "./AppReducer";
import storage from 'redux-persist/lib/storage'

const reducerMap = {
    OFFICE: officeReducer,
    AUTH: authReducer,
};

const rootReducer = (state, action) => {

    // if (action.type === 'AUTH/LOGOUT_SUCCESS') {
    //     storage.removeItem('persist:office');
    //     const selectedReducer = reducerMap.AUTH;
    //     return selectedReducer(state, action);
    // }

    if (action.type === 'AUTH/LOGOUT_SUCCESS') {
        storage.removeItem('persist:office');
        
        // Reset state to only include keys that authReducer expects (app, auth)
        const newState = {
            app: state?.app ? { ...state.app, config: {}, settings: {} } : undefined,
            auth: undefined, // Will be set by authReducer
        };

        const selectedReducer = reducerMap.AUTH;
        return selectedReducer(newState, action);
    }

    let mode = state?.app?.mode;

    if(action.type === 'APP/FETCH_CONFIG_SUCCESS'){
        mode = action.payload.data?.mode;
    }

    const selectedReducer = reducerMap[mode] || reducerMap.OFFICE;
    return selectedReducer(state, action);
};

export default rootReducer;